import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { type ButtonAction } from '@heidi/analytics/vocabulary';
import { useCallback } from 'react';

import { useEditorAnalytics } from './editor-analytics-context';

/**
 * Fires `button_clicked` (Snowplow + Datadog only) for a shared bubble-menu
 * button, stamped with the surrounding editor variant so events are segmentable
 * by editor. Routed through the `track()` facade with `amplitude: false` — the
 * Rematch containment ratchet freezes new `dispatch.analyticsScribe` call sites,
 * and this yields the same routing as the `trackButtonClicked` chokepoint.
 */
export const useTrackMenuClick = () => {
  const { editorType } = useEditorAnalytics();
  return useCallback(
    (action: ButtonAction, label: string) => {
      if (!editorType) return;

      track({
        event_name: TrackingEventName.ButtonClicked,
        props: { action, label, editor_type: editorType },
        options: { amplitude: false },
      });
    },
    [editorType]
  );
};
